import React, { useEffect, useState } from 'react';
import Modal from '../Modal';

import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as Spinner } from '../images/spinner.svg';

const NoTrafficModal = ({setEntry, entry}) => {
  let [lastTraffic, setLastTraffic] = useState(null);

  useEffect(() => {
    fetch(process.env.REACT_APP_SERVER_URL + '/api/get-last-traffic-date', {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        website_id: entry.website_id,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          let date = new Date(data.date * 1000);
          const now = new Date();
          const diffTime = Math.abs(now - date);
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          setLastTraffic(diffDays + ' days ago');
        }
      })
      .catch(error => console.log(error));
  }, [entry]);

  return (
    <Modal isOpen={true} zIndex={100}>
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '600px',
             borderRadius: '10px',
           }}>
        <div
          style={{
            margin: '1px',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '20px',
            backgroundColor: 'black',
          }}>
          <div style={{
                 display: 'flex',
                 flexDirection: 'row',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 width: '100%',
               }}>
            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              Details
            </span>

            <CloseIcon className='image'
                       style={{width: '15px',
                               height: '15px',
                               fill: 'white',
                              }}
                       onClick={() => setEntry(null)} />
          </div>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                      }}>
            <span style={{fontSize: '18px',
                          fontWeight: 'bold',
                          color: 'gray',
                         }}>
              User
            </span>
            <span>
              {entry.name}
            </span>
          </div>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                      }}>
            <span style={{fontSize: '18px',
                          fontWeight: 'bold',
                          color: 'gray',
                         }}>
              Domain
            </span>
            <span>
              {entry.domain}
            </span>
          </div>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                      }}>
            <span style={{fontSize: '18px',
                          fontWeight: 'bold',
                          color: 'gray',
                         }}>
              Last Traffic
            </span>

            {lastTraffic && (
              <span>
                {lastTraffic}
              </span>
            )}

            {!lastTraffic && (
              <Spinner style={{
                         width: '15px',
                         height: '15px',
                         animation: 'spin 1s linear infinite',
                       }} />
            )}
          </div>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                       justifyContent: 'center',
                      }}>
            <div style={{alignItems: 'center',
                         padding: '10px 20px',
                         backgroundColor: '#009de6',
                         color: 'white',
                         borderRadius: '5px',
                         cursor: 'pointer',
                         fontWeight: 'bold',
                         alignSelf: 'flex-end',
                         display: 'flex',
                         justifyContent: 'center',
                        }}
                 onClick={() => setEntry(null)}>
              OK
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default NoTrafficModal;
